import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { RequestsServices } from './../../services/requests.service';
import { PageBase } from '../../page.base';

@Component({
  selector: 'app-cupons',
  templateUrl: './cupons.page.html',
  providers: [ UserService, RequestsServices ]
})

export class cuponsComponent extends PageBase implements OnInit {
  public rows: any;
  public isLoadingCoupon: boolean;

  constructor(
    private userService: UserService,
    private request: RequestsServices) {
    super();
  }

  private fetchTable(): void {
    let idEstab = this.userService.getLoggedAccount()['id'];
    this.isLoadingCoupon = true;
    // TODO: remove &limit=10000 and add real Pagination
    this.request.get({ path: 'establishments', pathParam: `/${idEstab}/coupons?skip=0&limit=10000` }).then(
      (result) => {
        this.isLoadingCoupon = false;
        this.rows = result;
      }
    );
  }

  private generatedDate(val): string {
    return this.convertDate(val, 'll');
  }

  ngOnInit() {
    this.fetchTable();
  }

}
